import { gsap, ScrollTrigger } from "@gsap";
/**
 * Layout: Speaker - Overview
 * Slug: speaker_overview
 */

function animateSlides(slides) {
	gsap.from(slides, {
		autoAlpha: 0,
		y: -20,
		stagger: 0.1,
	});
}

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger);
    const layouts = document.querySelectorAll('.flex-layout.speaker_overview-layout');

	layouts.forEach((layout) => {
		const ajaxUrl = layout.getAttribute('data-ajax-url');
		const nonce = layout.getAttribute('data-nonce');
		const grid = layout.querySelector('#speakerGrid');
		const dayFilter = layout.querySelector('#dayFilter');
		const themeFilter = layout.querySelector('#themeFilter');
		const loadMoreBtn = layout.querySelector('#speakerLoadMore');
		const buttonGroup = loadMoreBtn ? loadMoreBtn.closest('.pk-button-group') : null;

		if (grid) {
			gsap.from(grid.querySelectorAll('.speaker-item'), {
				autoAlpha: 0,
				y: -20,
				stagger: 0.1,
				scrollTrigger: {
					trigger: grid,
					start: 'top center+=25%',
					markers: false,
				},
			});
		}

		if (!ajaxUrl || !grid || !buttonGroup) return;

		let paged = 1;
		let isLoading = false;

		function currentFilters() {
			return {
				day: dayFilter ? dayFilter.value : '',
				theme: themeFilter ? themeFilter.value : '',
			};
		}

		function removeExistingCards() {
			grid.querySelectorAll('.speaker-item').forEach((item) => item.remove());
		}

		function removeEmptyState() {
			const emptyState = grid.querySelector('.speaker-empty-state');
			if (emptyState) emptyState.remove();
		}

		function showEmptyState() {
			const emptyState = document.createElement('p');
			emptyState.className = 'speaker-empty-state';
			emptyState.textContent = 'No speakers found for the selected filters.';
			buttonGroup.insertAdjacentElement('beforebegin', emptyState);
		}

		function fetchSpeakers({ replace }) {
			if (isLoading) return;
			isLoading = true;
			grid.classList.add('is-filtering');

			const { day, theme } = currentFilters();
			const body = new URLSearchParams({
				action: 'filter_speakers',
				nonce: nonce || '',
				day: day || '',
				theme: theme || '',
				paged: String(paged),
			});

			fetch(ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body,
			})
				.then((response) => response.json())
				.then((response) => {
					if (!response || !response.success) return;

					const { html, hasMore } = response.data;

					if (replace) {
						removeExistingCards();
					}
					removeEmptyState();

					if (html) {
						buttonGroup.insertAdjacentHTML('beforebegin', html);
						if (replace) {
							animateSlides(grid.querySelectorAll('.speaker-item'));
						}
					} else if (replace) {
						showEmptyState();
					}

					loadMoreBtn.hidden = !hasMore;
				})
				.catch((error) => {
					console.error('Failed to load speakers:', error);
				})
				.finally(() => {
					isLoading = false;
					grid.classList.remove('is-filtering');
				});
		}

		function handleFilterChange() {
			paged = 1;
			fetchSpeakers({ replace: true });
		}

		if (dayFilter) dayFilter.addEventListener('change', handleFilterChange);
		if (themeFilter) themeFilter.addEventListener('change', handleFilterChange);

		loadMoreBtn.addEventListener('click', function() {
			paged++;
			fetchSpeakers({ replace: false });
		});
	});
});
